"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BillingApiReportPurchaseQueryDto = void 0;
const class_transformer_1 = require("class-transformer");
const swagger_1 = require("../../../../swagger-fake");
const class_validator_1 = require("class-validator");
const key_value_1 = require("../../../../shared/types/key-value");
const transform_json_string_1 = __importDefault(require("../../../../shared/pipes/transform-json-string"));
let BillingApiReportPurchaseQueryDto = class BillingApiReportPurchaseQueryDto {};
__decorate([(0, swagger_1.ApiProperty)({
  description: `Поиск операций связанных с конкретным(и) провайдером.
    Для поиска тестовых операций, нужно выбрать тестовых провайдеров.`,
  required: false,
  type: 'string',
  isArray: true,
  nullable: true,
  items: {
    format: 'uuid'
  }
}), (0, class_validator_1.IsOptional)(), (0, class_transformer_1.Expose)(), __metadata("design:type", Object)], BillingApiReportPurchaseQueryDto.prototype, "providerId", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Поиск операций связанных с конкретным(и) charge",
  required: false,
  type: 'string',
  isArray: true,
  nullable: true,
  items: {
    format: 'uuid'
  }
}), (0, class_validator_1.IsOptional)(), (0, class_transformer_1.Expose)(), __metadata("design:type", Object)], BillingApiReportPurchaseQueryDto.prototype, "chargeId", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Поиск операций связанных с конкретным(и) order",
  required: false,
  type: 'string',
  isArray: true,
  nullable: true,
  items: {
    format: 'uuid'
  }
}), (0, class_validator_1.IsOptional)(), (0, class_transformer_1.Expose)(), __metadata("design:type", Object)], BillingApiReportPurchaseQueryDto.prototype, "orderId", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Поиск операций связанных с конкретным(и) contractor",
  required: false,
  type: 'string',
  isArray: true,
  nullable: true,
  items: {
    format: 'uuid'
  }
}), (0, class_validator_1.IsOptional)(), (0, class_transformer_1.Expose)(), __metadata("design:type", Object)], BillingApiReportPurchaseQueryDto.prototype, "contractorId", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Поиск по свойствам мета-данных сделок",
  required: false,
  type: String,
  format: "json",
  example: "{\"meetingId\":\"202675c9-0700-4472-bb2e-a2d2c2b2c401\"}"
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsOptional)(), (0, transform_json_string_1.default)(), (0, class_transformer_1.Type)(() => key_value_1.Metadata), __metadata("design:type", key_value_1.Metadata)], BillingApiReportPurchaseQueryDto.prototype, "orderMeta", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Поиск по свойствам мета-данных начислений",
  required: false,
  type: String,
  format: "json",
  example: "{\"meetingId\":\"202675c9-0700-4472-bb2e-a2d2c2b2c401\"}"
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsOptional)(), (0, transform_json_string_1.default)(), (0, class_transformer_1.Type)(() => key_value_1.Metadata), __metadata("design:type", key_value_1.Metadata)], BillingApiReportPurchaseQueryDto.prototype, "chargeMeta", void 0);
BillingApiReportPurchaseQueryDto = __decorate([(0, class_transformer_1.Exclude)()], BillingApiReportPurchaseQueryDto);
exports.BillingApiReportPurchaseQueryDto = BillingApiReportPurchaseQueryDto;
